module.exports = __webpack_public_path__ + "static/media/switch-stack-card.71a16ec4.wav";